// app/(routes)/login/page.tsx
'use client';

import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

import { SiteFooter } from '@/components/site-footer';
import { SiteHeader } from '@/components/site-header';

import { AuthForm } from '../../auth/authForm';

function LoginContent() {
  const searchParams = useSearchParams();
  const redirectedFrom = searchParams.get('redirectedFrom') || undefined;
  
  return (
    <>
      <SiteHeader hideGetStarted />
      <div className="min-h-screen bg-gray-50 flex items-center">
        {/* Form Container - Constrained Width */}
        <div className="max-w-md mx-auto px-4 pb-12 w-full sm:px-6 lg:px-8">
          {/* Login Form */}
          <div className="bg-white rounded-lg shadow-sm border-t-8 border-secondary p-8">
            <div className="text-center mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Login
              </h3>
            </div>

            <AuthForm view="sign_in" redirectedFrom={redirectedFrom} />
          </div>
        </div>
      </div>
      <SiteFooter />
    </>
  );
}

export default function LoginPage() {
  return (
    <Suspense fallback={
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-center text-gray-400">Loading...</p>
      </div>
    }>
      <LoginContent />
    </Suspense>
  );
}

